import GoalsSerializer from './base';

export default class Goal extends GoalsSerializer {
  attrs = {
    linkedGoalIds: { serialize: 'ids' },
    priorLinkedGoalIds: { serialize: 'ids' },
    futureLinkedGoalIds: { serialize: 'ids' },
  };

  normalize(modelClass, payload) {
    payload.subject_id = payload.subjectId;
    return super.normalize(...arguments);
  }
}
